export default "__VITE_ASSET__2500ab34__"